var _path, _path2, _path3, _path4, _path5, _path6, _path7, _path8, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgApplePodcasts(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 48,
    height: 48,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M28.112 28.976c-.064-.576-.256-.992-.64-1.376-.72-.752-1.984-1.248-3.472-1.248s-2.752.48-3.472 1.248c-.368.4-.576.8-.64 1.376-.128 1.12-.048 2.08.08 3.632.128 1.472.368 3.44.672 5.424.224 1.424.4 2.192.56 2.736.272.896 1.248 1.664 2.8 1.664 1.552 0 2.544-.784 2.8-1.664.16-.544.336-1.312.56-2.736.304-2 .544-3.952.672-5.424.144-1.552.208-2.512.08-3.632z",
    fill: "#fff"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M28.112 28.976c-.064-.576-.256-.992-.64-1.376-.72-.752-1.984-1.248-3.472-1.248s-2.752.48-3.472 1.248c-.368.4-.576.8-.64 1.376-.128 1.12-.048 2.08.08 3.632.128 1.472.368 3.44.672 5.424.224 1.424.4 2.192.56 2.736.272.896 1.248 1.664 2.8 1.664 1.552 0 2.544-.784 2.8-1.664.16-.544.336-1.312.56-2.736.304-2 .544-3.952.672-5.424.144-1.552.208-2.512.08-3.632z",
    fill: "url(#paint0_linear_710_7106)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M27.936 20.816A3.933 3.933 0 0124 24.752a3.933 3.933 0 01-3.936-3.936A3.933 3.933 0 0124 16.88a3.943 3.943 0 013.936 3.936z",
    fill: "#fff"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M27.936 20.816A3.933 3.933 0 0124 24.752a3.933 3.933 0 01-3.936-3.936A3.933 3.933 0 0124 16.88a3.943 3.943 0 013.936 3.936z",
    fill: "url(#paint1_linear_710_7106)"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M23.952 5.312C14.768 5.344 7.248 12.8 7.12 21.984c-.096 7.44 4.656 13.808 11.296 16.144.16.064.32-.08.304-.24-.08-.576-.176-1.152-.24-1.728a.634.634 0 00-.336-.464c-5.248-2.288-8.912-7.552-8.848-13.648.08-8 6.608-14.512 14.592-14.576 8.176-.064 14.848 6.56 14.848 14.72 0 6.032-3.648 11.216-8.848 13.504a.543.543 0 00-.336.464l-.24 1.728c-.032.176.144.304.304.24 6.576-2.304 11.296-8.576 11.296-15.936-.032-9.312-7.632-16.896-16.96-16.88z",
    fill: "#fff"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M23.952 5.312C14.768 5.344 7.248 12.8 7.12 21.984c-.096 7.44 4.656 13.808 11.296 16.144.16.064.32-.08.304-.24-.08-.576-.176-1.152-.24-1.728a.634.634 0 00-.336-.464c-5.248-2.288-8.912-7.552-8.848-13.648.08-8 6.608-14.512 14.592-14.576 8.176-.064 14.848 6.56 14.848 14.72 0 6.032-3.648 11.216-8.848 13.504a.543.543 0 00-.336.464l-.24 1.728c-.032.176.144.304.304.24 6.576-2.304 11.296-8.576 11.296-15.936-.032-9.312-7.632-16.896-16.96-16.88z",
    fill: "url(#paint2_linear_710_7106)"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M23.568 10.912c-5.984.224-10.784 5.168-10.864 11.152a11.3 11.3 0 004.944 9.488c.144.096.352-.016.352-.192a15.706 15.706 0 01-.016-1.936.652.652 0 00-.224-.544 9.149 9.149 0 01-2.896-6.912c.128-4.8 3.984-8.704 8.784-8.896 5.216-.208 9.504 3.984 9.504 9.136 0 2.624-1.12 4.992-2.896 6.672a.762.762 0 00-.224.544c.032.624.016 1.232-.016 1.92-.016.176.192.304.352.192a11.323 11.323 0 004.944-9.344c.016-6.368-5.312-11.536-11.744-11.28z",
    fill: "#fff"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M23.568 10.912c-5.984.224-10.784 5.168-10.864 11.152a11.3 11.3 0 004.944 9.488c.144.096.352-.016.352-.192a15.706 15.706 0 01-.016-1.936.652.652 0 00-.224-.544 9.149 9.149 0 01-2.896-6.912c.128-4.8 3.984-8.704 8.784-8.896 5.216-.208 9.504 3.984 9.504 9.136 0 2.624-1.12 4.992-2.896 6.672a.762.762 0 00-.224.544c.032.624.016 1.232-.016 1.92-.016.176.192.304.352.192a11.323 11.323 0 004.944-9.344c.016-6.368-5.312-11.536-11.744-11.28z",
    fill: "url(#paint3_linear_710_7106)"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_710_7106",
    x1: 24.002,
    y1: 26.352,
    x2: 24.002,
    y2: 42.432,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F452FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832BC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_710_7106",
    x1: 24,
    y1: 16.88,
    x2: 24,
    y2: 24.752,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F452FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832BC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint2_linear_710_7106",
    x1: 24.015,
    y1: 5.312,
    x2: 24.015,
    y2: 38.145,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F452FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832BC1"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint3_linear_710_7106",
    x1: 24.008,
    y1: 10.903,
    x2: 24.008,
    y2: 31.587,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#F452FF"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#832BC1"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgApplePodcasts);
export default __webpack_public_path__ + "static/media/applePodcasts.d691ec262d3ac74365937e3967c8a6d0.svg";
export { ForwardRef as ReactComponent };